import { ReactNode } from 'react';

import SidebarLayout from 'src/layouts/SidebarLayout';
import { AdminWorkspaceProvider } from './AdminWorkspaceProvider';

export const AdminManagementBoundary = ({
  children
}: {
  children: ReactNode;
}) => (
  <AdminWorkspaceProvider>{children}</AdminWorkspaceProvider>
);

const AdminManagementLayout = () => (
  <AdminManagementBoundary>
    <SidebarLayout />
  </AdminManagementBoundary>
);

export default AdminManagementLayout;
